import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=04a921f0&"
import script from "./projectDetail.vue?vue&type=script&lang=js&"
export * from "./projectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports